import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconSpecificStudentsSvg } from './IconSpecificStudentsSvg';

export type IconSpecificStudentsProps = UseIconProps;

export function IconSpecificStudents(props: IconSpecificStudentsProps) {
  const iconProps = useIcon({ size: 'x-large', ...props });

  return <Box tagName={IconSpecificStudentsSvg} {...iconProps} />;
}
